module.exports = __webpack_public_path__ + "static/media/footer-logo.a8b2ec3d.png";